import Vue from 'vue'
import VueRouter from 'vue-router'
import ImageProcessing from '@/components/ImageProcessing.vue'
import ExcelViewer from '@/components/ExcelViewer.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/table',
    meta: {
      title: '智能表格識別系統'
    }
  },
  {
    path: '/table',
    name: 'TableRecognition',
    component: ImageProcessing,
    meta: {
      title: '表格識別'
    }
  },
  {
    path: '/excel',
    name: 'ExcelViewer',
    component: ExcelViewer,
    meta: {
      title: 'Excel編輯器'
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '智能表格識別系統'
  next()
})

export default router
